/* eslint-disable */
import { app, Component, on } from 'apprun';
import { auth, teams as teamApi } from './api';

const search = (state, e) => ({ ...state, filter: e.target.value });

const Item = ({ item }) => (
  // <tr class="hand" $onclick={['#team', item.id, item.name]}>
  <tr class="hand">
    <td>
      <a>{item.id}</a>
    </td>
    <td>
      <a>{item.name}</a>
    </td>
  </tr>
);

const List = ({ items }) => (
  <table class="table table-striped table-condensed table-bordered table-hover">
    <thead>
      <tr>
        <th>Id</th>
        <th>Name</th>
      </tr>
    </thead>
    <tbody>
      {items.map(item => (
        <Item item={item}  />
      ))}
    </tbody>
  </table>
);

export default class LocationListComponent extends Component {

  state = {};

  view = (state) => {
    if (!state || !state.teams) {return;}
    const teams = !state.filter
       ? state.teams
       : state.teams.filter(c => (c.name.toUpperCase() + c.id.toString()).indexOf(state.filter.toUpperCase()) >= 0);
    return <div style={{ width: '500px' }}>
      <div class="input-group">
        <input class="form-control" placeholder="Search..." $oninput={search} value={state.filter || ''} />
        <span class="input-group-btn">
          <button class="btn btn-default" $onclick={['#location', null, 'location [New]', state.companyId]} disabled={!state.createAllowed}> + </button>
        </span>
      </div>
      <List items={teams} />
    </div>;
  };

  @on('refresh')
  load = async (state, companyId) => {
    state.companyId = companyId;
    const teams = (await (teamApi.getTeams(companyId))) || [];
    console.log(teams);
    const createAllowed = auth.hasPermission('CompanyCreate', 'C');
    return { ...state, teams, createAllowed };
  }

  mounted = ({ state }) => {
    this.run('refresh', state.companyId);
  };
}
